import React, { FC, memo } from 'react';
import Employee from 'src/interfaces/api/Employee';
import { useRecoilState } from 'recoil';
import { employeeState } from 'src/recoil/selectors/employees';

interface Props {
  employeeId: Employee['id'];
}

const EmployeeCell: FC<Props> = ({ employeeId }) => {
  const [employee] = useRecoilState(employeeState(employeeId));

  return <div>{employee ? `${employee.firstname} ${employee.lastname}` : ''}</div>;
};

export default memo(EmployeeCell, (prevProps, nextProps) => prevProps.employeeId === nextProps.employeeId);
